export default "__VITE_ASSET__3e3a5413__"